const OFFERS_INFO = [
  {
    title: 'Trumny',
    description: `W sprzedaży posiadamy wiele modeli trumien o zróżnicowanej kolorystyce i kształtach. <br /><br />  Ceny trumien są zróżnicowane w zależności od rodzaju drzewa, modelu i wzoru. Nasz asortyment zadowoli zarówno bardzo wymagających Klientów, jak i tych dla których główne znaczenie mają koszty.`,
  },
  {
    title: 'Urny',
    description: `Oferujemy Państwu szeroką gamę urn wykonanych z drewna, metalu oraz kamienia. Ceny urn są zróżnicowane w zależności od modelu oraz wzoru.`,
  },
  {
    title: 'Nagrobki',
    description: `W naszej ofercie znajdą Państwo również nagrobki. <br /><br />W ciągłej sprzedaży mamy ponad 100 rodzai nagrobków.<br /><br />Wykonujemy nagrobki według życzeń klienta (kolor, kształt).<br /><br />Poniżej przedstawiamy zdjęcia niektórych z nich.`,
  },
  {
    title: 'Kwiaty',
    description: `Do Państwa dyspozycji pozostawiamy szeroki wybór kompozycji kwiatowych własnej produkcji, zarówno żywych, jak i sztucznych`,
  },
  {
    title: 'Kremacja',
    description: `Spopielanie ciała odbywa się w trumnie, w temperaturze od 800 do 1300 oC. Całkowity cykl kremacyjny trwa od 1,5 do 2 godzin. Następnie szczątki zmarłego składane są do urny i przekazywane rodzinie zmarłego wraz ze Świadectwem Kremacji. <br /><br />Pochówek spopielonego ciała odbywa się z zachowaniem wszelkich godności należnych zmarłemu a obrzędy pogrzebowe nie różnią się od tradycyjnego pochówku w trumnie.<br /><br />Spopielenia zwłok nie zabrania Kościół Katolicki, co zostało zapisane w kanonie 1176 §3 Kodeksu Prawa Kanonicznego. Potwierdził to również Papież Jan Paweł II w 1983 r.`,
  },
  {
    title: 'Eksportacja z domu',
    description: `Oferujemy Państwu całodobową eksportację ciała zmarłego. Prosimy o informację telefoniczną wraz z podaniem dokładnego adresu pod który pracownicy firmy mają się udać.`,
  },
  {
    title: 'Międzynarodowy transport zwłok',
    description: `Firma Nasza prowadzi także międzynarodowy transport zwłok.<br /><br />Dysponujemy trumnami przewozowymi ze specjalnymi wkładami do transportu zmarłych na duże odległości.<br /><br />Załatwiamy wszelkie formalności związane z przewozem zwłok min. dokumenty konsularne.`,
  },
  {
    title: 'Samochody',
    description: `Oferujemy swoim klientom pełny zakres usług związanych z przewozem zmarłych na terenie całego kraju. Nasze pojazdy przystosowane są do transportu trumien, przewozu zwłok oraz do uczestnictwa w orszaku żałobnym.`,
  },
  {
    title: 'Oprawa muzyczna',
    description: `Oferujemy Państwu szeroki zakres usług muzycznych.<br /><br />Przykładamy wielką uwagę by nadać ceremonii piękną i wzruszającą oprawę, dlatego dysponujemy orkiestrą dętą jak i profesjonalnym trębaczem, który tworzy uroczysty nastrój ceremonii pogrzebowej.`,
  },
  {
    title: 'ZUS',
    description: `Dla Państwa wygody nasza firma rozlicza zasiłek pogrzebowy ZUS.<br /><br />Aby zaoszczędzić Państwa czas jak również pomóc w dokonaniu formalności w celu wypłaty zasiłku pogrzebowego ZUS, przygotowujemy należne dokumenty i wypłata zasiłku następuje zaraz po rozliczeniu należności w stosunku do naszej firmy za organizacje uroczystości pogrzebowej.<br /><br />Nie pobieramy żadnych prowizji, kwota zasiłku jest taka sama jak w przypadku osobistego stawiennictwa w ZUS !!!`,
  },
  {
    title: 'Akcesoria pogrzebowe',
    description: `Posiadamy w swojej ofercie odzież żałobną oraz wyjątkowe krzyże ze stali nierdzewnej.`,
  },
];

export default OFFERS_INFO;
